import React from 'react'
import Pricing from './Pricing'
import FAQContactSection from '../LandingPagecomponents/FAQContactSection'
import Navbar from '../common/Navbar'
import Footer from '../common/Footer'




export default function PricingPage() {
  return (
    <div>
      <Navbar/>
      <Pricing/>
      <FAQContactSection />
      <Footer/>
    </div>
  )
}
